import { useQuery as r } from "@tanstack/react-query";
import { getTrailerBookingInformationRequest as o } from "../requests/getTrailerBookingInformation.js";
const i = (e) => r({
  queryKey: ["trailer-booking-information", e],
  queryFn: async () => await o(e),
  enabled: !1,
  retry: !1,
  staleTime: 6e5
});
export {
  i as useGetTrailerBookingInformation
};
